/**
 * An array representing the minimum selectable values from 1 to 24.
 * This can be used in dropdowns or selection components where a user
 * needs to choose a minimum value within this range.
 */
export const MINIMUM_SELECT = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
];